import { useCallback } from "react";
import { ResponsivePicture } from "src/atoms/ResponsivePicture";
import { lookbookImageLoader } from "src/utils/lookbook-image-loader";
import { PDP_GRID_IMAGE_WIDTHS } from "src/utils/image-widths";

type GridImageProps = {
  photo: string;
  productName: string;
  index: number;
  sizes: string;
  children?: React.ReactNode;
  handleImageClick?: (index: number) => void;
};

function GridImage({
  photo,
  productName,
  index,
  sizes,
  children,
  handleImageClick,
}: GridImageProps): JSX.Element {
  const handleImageLoad = useCallback(
    (event: React.SyntheticEvent<HTMLImageElement>) => {
      event.currentTarget?.parentElement?.setAttribute("data-loaded", "true");
    },
    []
  );

  const handleOnClick = useCallback(() => {
    if (handleImageClick) {
      handleImageClick(index);
    }
  }, [handleImageClick, index]);

  const handleKeyDown = useCallback(
    (event: React.KeyboardEvent) => {
      if ((event.key === "Enter" || event.key === " ") && handleImageClick) {
        event.preventDefault();
        handleImageClick(index);
      }
    },
    [handleImageClick, index]
  );

  return (
    <div
      key={`pdp-image-${index}`}
      className="image-container"
      onClick={handleOnClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      data-loaded="false"
    >
      <ResponsivePicture
        mobile={{ src: photo }}
        alt={`${productName} ${index + 1}`}
        sizes={sizes}
        widths={PDP_GRID_IMAGE_WIDTHS}
        loader={lookbookImageLoader}
        withContainer={false}
        onLoad={handleImageLoad}
      />
      {children}
    </div>
  );
}

export { GridImage };
